module.exports = __webpack_public_path__ + "static/media/syringe.81148150.svg";